/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsLayoutRouteImport } from './routes/settings/_layout'
import { Route as ChatLayoutRouteImport } from './routes/chat/_layout'
import { Route as SettingsLayoutIndexRouteImport } from './routes/settings/_layout.index'
import { Route as ChatLayoutIndexRouteImport } from './routes/chat/_layout.index'
import { Route as ChatLayoutThreadIdRouteImport } from './routes/chat/_layout.$threadId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLayoutRoute = SettingsLayoutRouteImport.update({
  id: '/settings/_layout',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const ChatLayoutRoute = ChatLayoutRouteImport.update({
  id: '/chat/_layout',
  path: '/chat',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsLayoutIndexRoute = SettingsLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsLayoutRoute,
} as any)
const ChatLayoutIndexRoute = ChatLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatLayoutRoute,
} as any)
const ChatLayoutThreadIdRoute = ChatLayoutThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => ChatLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/chat': typeof ChatLayoutRouteWithChildren
  '/settings': typeof SettingsLayoutRouteWithChildren
  '/chat/$threadId': typeof ChatLayoutThreadIdRoute
  '/chat/': typeof ChatLayoutIndexRoute
  '/settings/': typeof SettingsLayoutIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/chat/$threadId': typeof ChatLayoutThreadIdRoute
  '/chat': typeof ChatLayoutIndexRoute
  '/settings': typeof SettingsLayoutIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/chat/_layout': typeof ChatLayoutRouteWithChildren
  '/settings/_layout': typeof SettingsLayoutRouteWithChildren
  '/chat/_layout/$threadId': typeof ChatLayoutThreadIdRoute
  '/chat/_layout/': typeof ChatLayoutIndexRoute
  '/settings/_layout/': typeof SettingsLayoutIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/chat'
    | '/settings'
    | '/chat/$threadId'
    | '/chat/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login' | '/chat/$threadId' | '/chat' | '/settings'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/chat/_layout'
    | '/settings/_layout'
    | '/chat/_layout/$threadId'
    | '/chat/_layout/'
    | '/settings/_layout/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  ChatLayoutRoute: typeof ChatLayoutRouteWithChildren
  SettingsLayoutRoute: typeof SettingsLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/_layout': {
      id: '/settings/_layout'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/chat/_layout': {
      id: '/chat/_layout'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof ChatLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/_layout/': {
      id: '/settings/_layout/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsLayoutIndexRouteImport
      parentRoute: typeof SettingsLayoutRoute
    }
    '/chat/_layout/': {
      id: '/chat/_layout/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof ChatLayoutIndexRouteImport
      parentRoute: typeof ChatLayoutRoute
    }
    '/chat/_layout/$threadId': {
      id: '/chat/_layout/$threadId'
      path: '/$threadId'
      fullPath: '/chat/$threadId'
      preLoaderRoute: typeof ChatLayoutThreadIdRouteImport
      parentRoute: typeof ChatLayoutRoute
    }
  }
}

interface ChatLayoutRouteChildren {
  ChatLayoutThreadIdRoute: typeof ChatLayoutThreadIdRoute
  ChatLayoutIndexRoute: typeof ChatLayoutIndexRoute
}

const ChatLayoutRouteChildren: ChatLayoutRouteChildren = {
  ChatLayoutThreadIdRoute: ChatLayoutThreadIdRoute,
  ChatLayoutIndexRoute: ChatLayoutIndexRoute,
}

const ChatLayoutRouteWithChildren = ChatLayoutRoute._addFileChildren(
  ChatLayoutRouteChildren,
)

interface SettingsLayoutRouteChildren {
  SettingsLayoutIndexRoute: typeof SettingsLayoutIndexRoute
}

const SettingsLayoutRouteChildren: SettingsLayoutRouteChildren = {
  SettingsLayoutIndexRoute: SettingsLayoutIndexRoute,
}

const SettingsLayoutRouteWithChildren = SettingsLayoutRoute._addFileChildren(
  SettingsLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  ChatLayoutRoute: ChatLayoutRouteWithChildren,
  SettingsLayoutRoute: SettingsLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
